import React from "react";

export const Statistics = () => {
    return (
        <div></div>
    )
}